module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/a9dd1477f22d75060a8c3ef1fa06b3eb.png";